import { render, staticRenderFns } from "./DialogImage.vue?vue&type=template&id=62a569b1&scoped=true"
import script from "./DialogImage.vue?vue&type=script&lang=js"
export * from "./DialogImage.vue?vue&type=script&lang=js"
import style0 from "./DialogImage.vue?vue&type=style&index=0&id=62a569b1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62a569b1",
  null
  
)

export default component.exports